export default {
  state: false,
  FullName: "",
  NationalNumber: "",
  JobNumber: "",
  DepartmentClassificationsId: "",
  DepartmentId: "",
  JobType: "",
  ScientificDegreeId: "",
  StartingDateFrom: "",
  StartingDateTo: "",
  SortBy: "",
  BonusDueDateFilterType: "",
  TypeOfEndService: "",
  MustRetireSoon: "",
  perPage: "",
  currentPage: "",
  ConfirmedSalary:[]
};
